import common from './common.lang';
import membership from '~/routes/membership/membership.lang';
import pass from '~/routes/pass/pass.lang';
import paperwork from '~/routes/paperwork/paperwork.lang';
import videoVisit from '~/routes/videoVisit/videoVisit.lang';
import bookingWidget from '~/routes/booking-widget/bookingWidget.lang';
import confirmation from '~/routes/confirmation/confirmation.lang';
import photoIdUpload from '~/routes/photoIdUpload/photoIdUpload.lang';
import addInsurance from '~/routes/addInsurance/addInsurance.lang';

export default {
  common,
  membership,
  pass,
  paperwork,
  videoVisit,
  bookingWidget,
  confirmation,
  photoIdUpload,
  addInsurance,
};
